import React from "react";
import { Box, Button, useDisclosure } from "@chakra-ui/react";
import { IoAddOutline } from "react-icons/io5";
import { Form, Modal, TextInput } from "components";
import { getValidation, useCreateAnestheticProtocol } from "./duck";

const Create: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const create = useCreateAnestheticProtocol(onClose);

  return (
    <>
      <Button onClick={onOpen} leftIcon={<IoAddOutline />}>
        New Protocol
      </Button>

      <Modal
        title="Create New Anesthetic Protocol"
        onClose={onClose}
        isOpen={isOpen}
      >
        <Form {...getValidation()} onSubmit={create}>
          <Box py={6}>
            <TextInput name="name" label="Name" placeholder="Name" autoFocus />
          </Box>

          <Form.Controls submitText="Save">
            <Button
              color="gray.700"
              variant="outline"
              colorScheme="gray"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Form.Controls>
        </Form>
      </Modal>
    </>
  );
};

export default Create;
